import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiViewDocumentsConstants } from "../../unsecure-view-documents/service/unsecure-view-document.service.constants";
import { ApiRequestCommentsConstants } from "../../../shared/constants/api-constants/api-request-comments.constants";
let UnsecureCommentService = class UnsecureCommentService {
    http;
    constructor(http) {
        this.http = http;
    }
    getUnsecureLookupsObservable(params) {
        return this.http.get(`${ApiRequestCommentsConstants.URL}/${ApiRequestCommentsConstants.FUNCTION_GET_PUBLIC_BU_LOOKUPS}`, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    getRequestCommentObservable(params) {
        const url = `${ApiRequestCommentsConstants.URL}/${ApiRequestCommentsConstants.FUNCTION_GET_PUBLIC_REQUEST_COMMENT}`;
        return this.http.get(url, { params }).pipe(map(requestComment => {
            return requestComment;
        }));
    }
    saveUnsecureComment(params) {
        return this.http.post(`${ApiRequestCommentsConstants.URL}/${ApiRequestCommentsConstants.FUNCTION_SAVE_PUBLIC_COMMENT}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    uploadAttachment(document, key) {
        return this.http.post(`${ApiRequestCommentsConstants.URL}/${key}/${ApiRequestCommentsConstants.FUNCTION_UPLOAD_ATTACHMENT}`, document);
    }
    getAttachmentContentObservable(attachmentId) {
        return this.http.get(`${ApiViewDocumentsConstants.URL}/${attachmentId}/${ApiViewDocumentsConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    getResponsiblePersonsObservable(params) {
        return this.http.post(`${ApiRequestCommentsConstants.URL}/GetPublicResponsiblePersons`, params).pipe(map(response => {
            return response.value;
        }));
    }
    getStepMetaObservable(params, key) {
        return this.http.get(`${ApiRequestCommentsConstants.URL}/${key}/GetPublicStepMetaData`, { params });
    }
    getModuleRoleAndUsersObservable(params, key) {
        return this.http.get(`${ApiRequestCommentsConstants.URL}/${key}/GetPublicModuleRoleAndUsers`, { params }).pipe(map(result => {
            return result.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
UnsecureCommentService = __decorate([
    Injectable({
        providedIn: "root"
    })
], UnsecureCommentService);
export { UnsecureCommentService };
